import { LayoutDashboard } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { tourAnchor } from '~/helpers/tour/anchors'
import { cn } from '~/lib/utils'

/**
 * Navigation de l'en-tête apprenant (#109). Le logo ramenait déjà à l'accueil,
 * mais rien ne le disait : un lien nommé rend le retour évident, et son état
 * actif dit à l'apprenant où il se trouve.
 *
 * `end` : actif sur l'accueil seulement, pas sur l'écran d'un parcours
 * (`/my-sessions/:id`), qui n'est pas le tableau de bord.
 */
function LearnerNav() {
  const { t } = useTranslation()

  return (
    <nav aria-label={t('home.nav.label')}>
      <NavLink
        to="/my-sessions"
        end
        {...tourAnchor('learner.dashboard')}
        className={({ isActive }) => cn(
          'inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
          // La marque en texte, sa teinte lisible sur `muted` (RGAA 3.2) : l'onglet
          // actif est l'une des rares touches de marque du cadre (#307).
          isActive
            ? 'bg-muted text-primary-text'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground',
        )}
      >
        <LayoutDashboard className="size-4" aria-hidden />
        {/* Jusqu'à la tablette, l'icône seule : le nom reste lu par les lecteurs
            d'écran, et la barre garde la place du logo et de la recherche (#307). */}
        <span className="sr-only md:not-sr-only">{t('home.nav.dashboard')}</span>
      </NavLink>
    </nav>
  )
}

export default LearnerNav
